<!--
 * @Author: Zheng Lei
 * @Email: baimoc@163.com
 * @Date: 2021-03-03 10:49:23
 * @LastEditTime: 2022-02-14 11:26:25
 * @FilePath: \raacfold\src\components\laside\FeatureBar.vue
-->
<template>
    <div class="raac-bar">
        <div class="raac-num" :style="{background: feature['color']}">
            {{feature['data'].length}}
        </div>
        <div class="raac-seq">
            <span style="color: #57606f">{{feature['name']}}</span>
        </div>
        <div class="raac-color-picker raac-bar" @click="visibleClick" style="cursor: pointer">
            <i v-if="is_visible" class="icon-font icon-see"></i>
            <i v-else class="icon-font icon-bukejian" :style="{color: '#747d8c'}"></i>
        </div>
        <div class="raac-color-picker raac-bar">
            <el-color-picker
                    v-model="color"
                    :predefine="predefineColors">
            </el-color-picker>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ExpBrowser",
        data() {
            return {
                color: '',
                feature_name: '',
                is_visible: true,
                predefineColors: [
                    '#ff4500',
                    '#ff8c00',
                    '#ffd700',
                    '#90ee90',
                    '#00ced1',
                    '#1e90ff',
                    '#c71585',
                ],
            };
        },
        props: {
            index: Number,
            feature: Object,
        },
        watch: {
            color() {
                this.update_color();
            },
            is_visible() {
                this.update_visible();
            },
        },
        components: {},
        mounted() {
            this.color = this.feature['color'];
        },
        methods: {
            visibleClick() {
                this.is_visible = !this.is_visible;
            },
            update_color(){
                let features_data = this.$store.state.features_data;
                let selection_setting = this.$store.state.structure_selection_setting;
                if (features_data[this.index]['color'] !== this.color){
                    features_data[this.index]['color'] = this.color;
                    selection_setting['color'] = this.color;
                    this.$store.commit('featuresDataMutation', features_data);
                    this.$store.commit('StructureSelectionSettingMutation', selection_setting);
                    // console.log(this.$store.state.features_data);
                }
            },
            update_visible(){
                let features_data = this.$store.state.features_data;
                if (features_data[this.index]['visible'] !== this.is_visible){
                    features_data[this.index]['visible'] = this.is_visible;
                    this.$store.commit('featuresDataMutation', features_data);
                    // console.log(this.$store.state.features_data);
                }
            }
        },
    };

</script>

<style scoped>

</style>
